"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderObject = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Renders a JSX element based on the provided object.
 * @param {any} object - The object to render. This can be a valid JSX element, an object with keys,or any other value that is not renderable (e.g., null, undefined, string, number).
 * @returns {JSX.Element|null} The rendered JSX element, or null if the action is not renderable.
 */
const renderObject = object => {
  if (_react.default.isValidElement(object)) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, object);
  } else if (object && typeof object === 'object' && Object.keys(object).length > 0) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, object);
  } else {
    return null;
  }
};
exports.renderObject = renderObject;